import React, { useEffect, useRef, useContext } from 'react'
import { NavLink } from 'react-router-dom'

import { AuthContext } from '../../context/auth/authContext'
import history from '../../history'

import { ApiContext } from '../../context/api/apiContext'

const Header = (props) => {
  const headerEl = useRef(null)
  const btnMenuTrigger = useRef(null)
  const { currentUser, handleSignOut } = useContext(AuthContext)
  const { jsonData } = useContext(ApiContext)
  const { header: headerData } = jsonData.defaultSectionSettings

  let scrollTop = 0
  let isFixed = false
  let $body = document.body
  let isMenuOpen = false

  const onScroll = () => {
    scrollTop = window.pageYOffset

    if (scrollTop > 10 && !isFixed) {
      headerEl.current.classList.add('scroll_mod')
      isFixed = true
    } else if (scrollTop < 10 && isFixed) {
      headerEl.current.classList.remove('scroll_mod')
      isFixed = false
    }
  }

  const handleMenuOnClick = (e, path) => {
    e.preventDefault()

    if (isMenuOpen) {
      $body.classList.remove('menu_open')
      btnMenuTrigger.current.classList.remove('active_mod')
    }

    history.push(path)
  }

  const handleTriggerOnClick = () => {
    if (isMenuOpen) {
      $body.classList.remove('menu_open')
      btnMenuTrigger.current.classList.remove('active_mod')
      isMenuOpen = false
    } else {
      $body.classList.add('menu_open')
      btnMenuTrigger.current.classList.add('active_mod')
      isMenuOpen = true
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', onScroll)

    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  }, [])

  return (
    <header className='header' ref={headerEl}>
      <div className='header_in'>
        <NavLink className='logo' to='/'>
          <img
            className='logo_img'
            src={headerData.logoImg}
            alt={headerData.logoAlt}
          />
        </NavLink>
        <div className='header_info'>
          <nav className='main_menu'>
            <div className='main_menu_in'>
              <ul className='main_menu_list header_mod'>
                {headerData.mainMenuItems.map(({ path, title }, index) => (
                  <li className='main_menu_item' key={title}>
                    <NavLink
                      to={path}
                      className='main_menu_link'
                      activeClassName='active_state'
                      onClick={(e) => handleMenuOnClick(e, path)}
                    >
                      {title}
                    </NavLink>
                  </li>
                ))}
                {currentUser ? (
                  <li className='main_menu_item'>
                    <NavLink
                      to={headerData.myStreamLinkUrl}
                      className='main_menu_link'
                      activeClassName='active_state'
                      onClick={(e) =>
                        handleMenuOnClick(e, headerData.myStreamLinkUrl)
                      }
                    >
                      {headerData.myStreamLinkTitle}
                    </NavLink>
                  </li>
                ) : null}
              </ul>
            </div>
          </nav>
          {currentUser ? (
            <a className='btn_base_v1 header_mod' onClick={handleSignOut}>
              {signOutLinkTitle}
            </a>
          ) : (
            <NavLink className='btn_base_v1 header_mod' to='/login'>
              {headerData.loginLinkTitle}
            </NavLink>
          )}
          <div
            className='menu_trigger menuTrigger'
            ref={btnMenuTrigger}
            onClick={handleTriggerOnClick}
          >
            <span className='menu_trigger_decor' />
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
